import React from "react";

const Teams = () => {
  return (
    <section id="team" className="py-24 bg-gray-900">
      <div className="container mx-auto px-4 text-center">
        <h2
          className="text-4xl md:text-5xl font-extrabold mb-12 text-blue-100"
          data-aos="fade-up"
        >
          Notre Équipe
        </h2>
        <div className="flex flex-col md:flex-row items-center md:justify-center gap-4 md:gap-8 flex-wrap">
          {/* Membre de l'équipe 1 */}
          <div
            className="bg-gray-700 p-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 w-full md:w-96 h-auto md:h-96 flex flex-col items-center justify-center"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <img
              src="/images/owen.jpeg"
              alt="Dayes Owen"
              className="w-32 md:w-48 h-32 md:h-48 object-cover rounded-full mb-4"
            />
            <h3 className="text-lg md:text-xl font-semibold text-blue-100 mb-2">
              Dayes Owen
            </h3>
            <p className="text-gray-300">Développeur Web et Mobile</p>
            <p className="mt-3 flex gap-2">
              <i className="fas fa-laptop-code fa-1x mb-4 text-blue-500"></i>
              <i className="fas fa-mobile-alt fa-1x mb-4 text-green-500"></i>
              <i className="fas fa-search fa-1x mb-4 text-yellow-500"></i>
              <i className="fas fa-share-alt fa-1x mb-4 text-red-500"></i>
            </p>
          </div>
          {/* Membre de l'équipe 2 */}
          <div
            className="bg-gray-700 p-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 w-full md:w-96 h-auto md:h-96 flex flex-col items-center justify-center"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <img
              src="/images/elisa.jpeg"
              alt="Leblond Elisa"
              className="w-32 md:w-48 h-32 md:h-48 object-cover rounded-full mb-4"
            />
            <h3 className="text-lg md:text-xl font-semibold text-blue-100 mb-2">
              Leblond Elisa
            </h3>
            <p className="text-gray-300">Designer UX/UI</p>
            <p className="mt-3 flex gap-2">
              <i className="fas fa-paint-brush fa-1x mb-4 text-purple-500"></i>
              <i className="fas fa-search fa-1x mb-4 text-yellow-500"></i>
              <i className="fas fa-share-alt fa-1x mb-4 text-red-500"></i>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Teams;
